<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/flowVoucherList' }">流向凭据</el-breadcrumb-item>
                <el-breadcrumb-item>流向凭据{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleDetailsForm"
                        :label-position="labelPosition"
                        class="details_temp2023"
                    >
                        <el-form-item label="代码：" prop="code">
                            <el-input
                                v-model="ruleForm.code"
                                size="mini"
                                placeholder="请输入代码"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="URL：" prop="url">
                            <el-input
                                v-model="ruleForm.url"
                                size="mini"
                                placeholder="请输入URL"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="用户名：" prop="username">
                            <el-input
                                v-model="ruleForm.username"
                                size="mini"
                                placeholder="请输入用户名"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="密码：" prop="password">
                            <el-input
                                v-model="ruleForm.password"
                                size="mini"
                                placeholder="请输入密码"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="验证信息：" prop="verification_info">
                            <el-input
                                v-model="ruleForm.verification_info"
                                size="mini"
                                placeholder="请输入验证信息"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="数据构成：" prop="data_composition">
                            <el-input
                                v-model="ruleForm.data_composition"
                                size="mini"
                                placeholder="请输入数据构成"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="数据文件后缀：" prop="datafile_suffix">
                            <el-input
                                v-model="ruleForm.datafile_suffix"
                                size="mini"
                                placeholder="请输入数据文件后缀"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="状态：" prop="status">
                            <el-select v-model="ruleForm.status" placeholder="请选择凭据状态" clearable :disabled="tl_readonly">
                                <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="源账户：" prop="source_account_name">
                            <el-select
                                :disabled="tl_readonly"
                                style="width: 100%"
                                v-model="ruleForm.source_account_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入源账户搜索"
                                :remote-method="remoteMethod"
                                :loading="parentLoading"
                                size="mini"
                                clearable
                                @change="parentChange"
                                value-key="rid"
                            >
                                <el-option v-for="item in parentOptions" :key="item.rid" :label="item.name" :value="item"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：" prop="remark">
                            <el-input
                                v-model="ruleForm.remark"
                                size="mini"
                                placeholder="请输入备注"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="网站代码：" prop="web_code">
                            <el-input
                                v-model="ruleForm.web_code"
                                size="mini"
                                placeholder="请输入网站代码"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="参数：" prop="parameter">
                            <el-input
                                v-model="ruleForm.parameter"
                                size="mini"
                                placeholder="请输入参数"
                                clearable
                                :disabled="tl_readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="说明：" prop="description">
                            <el-input v-model="ruleForm.description" size="mini" placeholder="请输入说明" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="人员：" prop="person_rid">
                            <vDropdown
                                model_key="person_rid"
                                model_name="请选择人员"
                                :model_value_default="ruleForm['person_rid']"
                                request_uri="dropdownPerson"
                                @onDropChange="onDropChange"
                                ref="person_rid"
                            ></vDropdown>
                        </el-form-item>
                        <el-form-item label="创建人：" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by }}
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array } from '../../../../js/common';
export default {
    name: 'flowVoucherEdit',
    data() {
        return {
            tl_readonly: false,
            btnLoading: false,
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {
                source_account_rid: '',
                source_account_name: '',
                code: '',
                url: '',
                username: '',
                password: '',
                verification_info: '',
                data_composition: '',
                datafile_suffix: '',
                remark: '',
                status: '',
                web_code: '',
                parameter: '',
                description: '',
                person_rid: ''
            },
            rules: {
                source_account_name: [{ required: true, message: '请输入源账户', trigger: 'blur' }],
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                url: [{ required: true, message: '请输入URL', trigger: 'blur' }],
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                data_composition: [{ required: true, message: '请输入数据构成', trigger: 'blur' }],
                datafile_suffix: [{ required: true, message: '请输入数据文件后缀', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
            },
            parentOptions: [],
            statusOptions: [],
            parentLoading: false
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        if (this.type == 1) {
            let roles = JSON.parse(localStorage.getItem('roles'));
            if (roles != null && in_array(process.env.VUE_APP_TL_ROLE_ID, roles)) {
                this.tl_readonly = true;
            } else {
                this.tl_readonly = false;
            }
        }
        this.getStatus();
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else {
            this.ruleForm = {
                source_account_rid: '',
                source_account_name: '',
                code: '',
                url: '',
                username: '',
                password: '',
                verification_info: '',
                data_composition: '',
                datafile_suffix: '',
                remark: '',
                status: '',
                web_code: '',
                parameter: '',
                description: '',
                person_rid: ''
            };
        }
    },
    methods: {
        onDropChange(key, value) {
            this.ruleForm[key] = value;
        },
        parentChange(value) {
            this.ruleForm.source_account_rid = value.rid;
            if (value) {
                this.ruleForm.code = value.code + 'A';
            } else {
                this.ruleForm.code = '';
            }
        },
        //账户名称远程搜索方法
        remoteMethod(query) {
            if (query !== '') {
                this.parentLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.parentLoading = false;
                                this.parentOptions = res.data;
                            }, 200);
                        } else {
                            this.parentOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.parentLoading = false;
                this.parentOptions = [];
            }
        },
        //状态列表
        getStatus() {
            let params = {};
            this.$api
                .dropdownCredentialStatus(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.statusOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/flowVoucherList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .commodityFlowSourceCredentialDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = res.data;
                    }
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                source_account_rid: this.ruleForm.source_account_rid,
                code: this.ruleForm.code,
                url: this.ruleForm.url,
                username: this.ruleForm.username,
                password: this.ruleForm.password,
                verification_info: this.ruleForm.verification_info ? this.ruleForm.verification_info : '',
                data_composition: this.ruleForm.data_composition,
                datafile_suffix: this.ruleForm.datafile_suffix,
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                web_code: this.ruleForm.web_code ? this.ruleForm.web_code : '',
                parameter: this.ruleForm.parameter ? this.ruleForm.parameter : '',
                status: this.ruleForm.status,
                description: this.ruleForm.description ? this.ruleForm.description : '',
                person_rid: this.ruleForm.person_rid ? this.ruleForm.person_rid : '',
                rid: this.rid
            };
            this.$api
                .commodityFlowSourceCredentialUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                source_account_rid: this.ruleForm.source_account_rid,
                code: this.ruleForm.code,
                url: this.ruleForm.url,
                username: this.ruleForm.username,
                password: this.ruleForm.password,
                verification_info: this.ruleForm.verification_info ? this.ruleForm.verification_info : '',
                data_composition: this.ruleForm.data_composition,
                datafile_suffix: this.ruleForm.datafile_suffix,
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                web_code: this.ruleForm.web_code ? this.ruleForm.web_code : '',
                parameter: this.ruleForm.parameter ? this.ruleForm.parameter : '',
                description: this.ruleForm.description ? this.ruleForm.description : '',
                person_rid: this.ruleForm.person_rid ? this.ruleForm.person_rid : '',
                status: this.ruleForm.status
            };
            this.$api
                .commodityFlowSourceCredentialInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>